<template>
  <div>
    <div v-for="(care, key) of item.quantity_of_times_checked" :key="key">
      <div
        v-if="care.checked_user && care.status == 'CHECADO'"
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 text-center"
      >
        <h6
          :class="[
            'text-eleven upper-text mb-0 p-1 user-name-checked',
            handleColorUser(item.prescription_care_time.time),
          ]"
          v-for="doc in professionalClassCouncilValue({
            id: care.checked_user.professional_class_council_id,
            name: care.checked_user.name,
            cpf: care.checked_user.cpf,
            value: care.checked_user.professional_class_council_value,
            profile: item.checked_user.profile_name,
          })"
          :key="doc.position"
        >
          {{ doc.text }}
        </h6>
        <img
          class="checked-icon"
          v-if="care.status == 'CHECADO' && care.checked"
          :src="require('../../../../../assets/check/checked.svg')"
        />
        <img
          class="checked-icon"
          v-if="care.status == 'CHECADO' && !care.checked"
          :src="require('../../../../../assets/check/hefty.svg')"
        />
      </div>
    </div>

    <h6
      v-if="item.status == 'SUSPENSO'"
      class="text-prescription-care-suspended text-center p-1"
    >
      SUSPENSO
    </h6>

    <div
      v-if="item.status == 'CHECADO'"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-1"
    ></div>
  </div>
</template>

<script>
import {
  categoryCoren,
  onlyCategoryCoren,
  formatTimeOnlyNumbers,
} from "../../../../../lib/format";

export default {
  name: "Eventual",
  props: {
    item: Object,
  },
  methods: {
    categoryCoren,
    onlyCategoryCoren,
    formatTimeOnlyNumbers,
    handleColorUser(time) {
      if (
        parseInt(formatTimeOnlyNumbers(time)) >= parseInt(70000) &&
        parseInt(formatTimeOnlyNumbers(time)) < parseInt(190000)
      ) {
        return "c-primary";
      }

      return "c-danger";
    },
    professionalClassCouncilValue({
      id = null,
      name = "",
      cpf = "",
      value = "",
      // profile = "",
    }) {
      const TYPE_COREN = 1;
      const TYPE_CRM = 2;

      name = String(name).split(" ");
      name = `${name[0]} ${name[1] ? String(name[1]).substr(0, 3) : ""}.`;

      if (id == TYPE_COREN) {
        // let category = categoryCoren(onlyCategoryCoren(value));
        value = String(value).substr(9);
        value = String(value).substr(0, value.length - 3);

        return [
          { position: 1, text: `${name} ${value}` },
          // { position: 2, text: value },
          // { position: 3, text: category },
        ];
      }

      if (id == TYPE_CRM) {
        return [
          { position: 1, text: `${name} ${value}` },
          // { position: 2, text: value },
        ];
      }

      return [
        { position: 1, text: `${name} ${cpf}` },
        // { position: 2, text: cpf },
      ];
    },
  },
};
</script>
